import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Estate Planning checklist screen
import { EstatePlanningChecklistScreen } from '../../screens/checklists/EstatePlanningChecklistScreen';

// Living Trust Preferences screens (existing)
import { LivingTrustPreferencesDataScreen } from '../../screens/tasks/finalCare/livingTrust/LivingTrustPreferencesDataScreen';
import { LivingTrustPreferencesInputScreen } from '../../screens/tasks/finalCare/livingTrust/LivingTrustPreferencesInputScreen';
import { LivingTrustPreferencesIntroScreen } from '../../screens/tasks/finalCare/livingTrust/LivingTrustPreferencesIntroScreen';
import { LivingTrustPreferencesLockedScreen } from '../../screens/tasks/finalCare/livingTrust/LivingTrustPreferencesLockedScreen';
import { LivingTrustPreferencesLockUnlockScreen } from '../../screens/tasks/finalCare/livingTrust/LivingTrustPreferencesLockUnlockScreen';
import { LivingTrustPreferencesUnlockedScreen } from '../../screens/tasks/finalCare/livingTrust/LivingTrustPreferencesUnlockedScreen';

// Will screens
import { WillDataScreen } from '../../screens/tasks/estatePlanning/will/WillDataScreen';
import { WillInputScreen } from '../../screens/tasks/estatePlanning/will/WillInputScreen';
import { WillIntroScreen } from '../../screens/tasks/estatePlanning/will/WillIntroScreen';
import { WillLockedScreen } from '../../screens/tasks/estatePlanning/will/WillLockedScreen';
import { WillLockUnlockScreen } from '../../screens/tasks/estatePlanning/will/WillLockUnlockScreen';
import { WillUnlockedScreen } from '../../screens/tasks/estatePlanning/will/WillUnlockedScreen';

// Financial POA screens
import { FinancialPOADataScreen } from '../../screens/tasks/estatePlanning/financialPOA/FinancialPOADataScreen';
import { FinancialPOAInputScreen } from '../../screens/tasks/estatePlanning/financialPOA/FinancialPOAInputScreen';
import { FinancialPOAIntroScreen } from '../../screens/tasks/estatePlanning/financialPOA/FinancialPOAIntroScreen';
import { FinancialPOALockedScreen } from '../../screens/tasks/estatePlanning/financialPOA/FinancialPOALockedScreen';
import { FinancialPOALockUnlockScreen } from '../../screens/tasks/estatePlanning/financialPOA/FinancialPOALockUnlockScreen';
import { FinancialPOAUnlockedScreen } from '../../screens/tasks/estatePlanning/financialPOA/FinancialPOAUnlockedScreen';

// Beneficiary Designations screens
import { BeneficiaryDesignationsDataScreen } from '../../screens/tasks/estatePlanning/beneficiaryDesignations/BeneficiaryDesignationsDataScreen';
import { BeneficiaryDesignationsInputScreen } from '../../screens/tasks/estatePlanning/beneficiaryDesignations/BeneficiaryDesignationsInputScreen';
import { BeneficiaryDesignationsIntroScreen } from '../../screens/tasks/estatePlanning/beneficiaryDesignations/BeneficiaryDesignationsIntroScreen';
import { BeneficiaryDesignationsLockedScreen } from '../../screens/tasks/estatePlanning/beneficiaryDesignations/BeneficiaryDesignationsLockedScreen';
import { BeneficiaryDesignationsLockUnlockScreen } from '../../screens/tasks/estatePlanning/beneficiaryDesignations/BeneficiaryDesignationsLockUnlockScreen';
import { BeneficiaryDesignationsUnlockedScreen } from '../../screens/tasks/estatePlanning/beneficiaryDesignations/BeneficiaryDesignationsUnlockedScreen';

const Stack = createNativeStackNavigator();

const EstatePlanningStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="EstatePlanningChecklist" component={EstatePlanningChecklistScreen} />

      {/* Living Trust Preferences screens */}
      <Stack.Screen name="LivingTrustPreferencesIntro" component={LivingTrustPreferencesIntroScreen} />
      <Stack.Screen name="LivingTrustPreferencesInput" component={LivingTrustPreferencesInputScreen} />
      <Stack.Screen name="LivingTrustPreferencesLockUnlock" component={LivingTrustPreferencesLockUnlockScreen} />
      <Stack.Screen name="LivingTrustPreferencesUnlocked" component={LivingTrustPreferencesUnlockedScreen} />
      <Stack.Screen name="LivingTrustPreferencesLocked" component={LivingTrustPreferencesLockedScreen} />
      <Stack.Screen name="LivingTrustPreferencesData" component={LivingTrustPreferencesDataScreen} />

      {/* Will screens */}
      <Stack.Screen name="WillIntro" component={WillIntroScreen} />
      <Stack.Screen name="WillInput" component={WillInputScreen} />
      <Stack.Screen name="WillLockUnlock" component={WillLockUnlockScreen} />
      <Stack.Screen name="WillUnlocked" component={WillUnlockedScreen} />
      <Stack.Screen name="WillLocked" component={WillLockedScreen} />
      <Stack.Screen name="WillData" component={WillDataScreen} />

      {/* Financial POA screens */}
      <Stack.Screen name="FinancialPOAIntro" component={FinancialPOAIntroScreen} />
      <Stack.Screen name="FinancialPOAInput" component={FinancialPOAInputScreen} />
      <Stack.Screen name="FinancialPOALockUnlock" component={FinancialPOALockUnlockScreen} />
      <Stack.Screen name="FinancialPOAUnlocked" component={FinancialPOAUnlockedScreen} />
      <Stack.Screen name="FinancialPOALocked" component={FinancialPOALockedScreen} />
      <Stack.Screen name="FinancialPOAData" component={FinancialPOADataScreen} />

      {/* Beneficiary Designations screens */}
      <Stack.Screen name="BeneficiaryDesignationsIntro" component={BeneficiaryDesignationsIntroScreen} />
      <Stack.Screen name="BeneficiaryDesignationsInput" component={BeneficiaryDesignationsInputScreen} />
      <Stack.Screen name="BeneficiaryDesignationsLockUnlock" component={BeneficiaryDesignationsLockUnlockScreen} />
      <Stack.Screen name="BeneficiaryDesignationsUnlocked" component={BeneficiaryDesignationsUnlockedScreen} />
      <Stack.Screen name="BeneficiaryDesignationsLocked" component={BeneficiaryDesignationsLockedScreen} />
      <Stack.Screen name="BeneficiaryDesignationsData" component={BeneficiaryDesignationsDataScreen} />
    </Stack.Navigator>
  );
};

export default EstatePlanningStackNavigator;
